module.exports = __webpack_public_path__ + "static/media/sahara.6df73311.jpg";